import { useState, useEffect } from "react";
import "./ShoppingCartPage.css";
import React from "react";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import Footer from "../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { sendCostAction } from "../store/actions/sendCostAction";
import { showNavUserAction } from "../store/actions/showNavUserAction";

function ShoppingCartPage() {
  const items = useSelector((state) => state.shoppingCart);
  const isLoggedIn = useSelector((state) => state.user_auth.token);
  console.log(items);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // const [subtotal, setSubtotal] = useState(0);
  // const [quantity, setQuantity] = useState(1);
  // const [subtotals, setSubtotals] = useState([]);
  const [subtotal, setSubTotal] = useState(0);
  const [shippingCost, setShippingCost] = useState(0);
  const dispatch = useDispatch();

  // const shippingOptions = { 1: 0, 2: 200, 3: 500 };

  const selectShipping = (ev) => {
    if (subtotal >= 1000) {
      setShippingCost(0);
    } else {
      setShippingCost(Number(ev.target.value));
    }
    dispatch(sendCostAction(Number(ev.target.value)));
  };

  const handleDelete = (item) => {
    dispatch({
      type: "DELETE_ITEM",
      payload: item,
    });
    toast.info(` Se ha eliminado su artículo correctamente`, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    setSubTotal(0);
    items.forEach((element) => {
      setSubTotal((prev) => prev + element.price * element.quantity);
    });
    window.scrollTo(0, 0);
  }, [items]);

  return (
    <>
      <div className="container content">
        <div className="col-lg-6">
          <div className="mx-4">
            <div className="d-flex justify-content-between align-items-center shadow rounded p-3">
              <h3>Carrito de compras</h3>
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="shopping-bag"
                  className="svg-inline--fa fa-shopping-bag fa-w-14"
                  role="img"
                  viewBox="0 0 448 512"
                  width="2em"
                  height="2em"
                >
                  <path
                    fill="currentColor"
                    d="M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
                  />
                </svg>
              </div>
            </div>
            <div className="cart-content shadow rounded p-3">
              {items.length > 0 ? (
                items.map((item) => (
                  <div key={item._id} className="cart-item d-flex align-items-center">
                    <div
                      className="d-flex justify-content-end align-text-top btn"
                      onClick={handleShow}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="far"
                        data-icon="trash-alt"
                        className="svg-inline--fa fa-trash-alt fa-w-14"
                        role="img"
                        viewBox="0 0 448 512"
                        width="1.2em"
                        height="1.2em"
                      >
                        <path
                          fill="currentColor"
                          d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
                        />
                      </svg>
                    </div>
                    <>
                      <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                          <Modal.Title>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              focusable="false"
                              data-prefix="far"
                              data-icon="trash-alt"
                              className="svg-inline--fa fa-trash-alt fa-w-14"
                              role="img"
                              viewBox="0 0 448 512"
                              width="1.2em"
                              height="1.2em"
                            >
                              <path
                                fill="currentColor"
                                d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
                              />
                            </svg>{" "}
                            Eliminar{" "}
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          ¿Estás seguro que deseas eliminar todas las unidades de este artículo?
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="danger" onClick={handleClose}>
                            Volver
                          </Button>
                          <Button
                            className="btn btn-wine"
                            onClick={() => {
                              handleDelete(item);
                              handleClose();
                            }}
                          >
                            Eliminar
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "60px", width: "100px" }}
                    >
                      <img
                        src={`${item.picture}`}
                        alt={item.name}
                        style={{ height: "50px", width: "auto" }}
                      />
                    </div>

                    <div className="d-flex align-items-center">
                      <div className="item-details p-3 text-muted">
                        <h5>${item.price} c/u</h5>
                        <p>{item.name}</p>
                        <div className="box" style={{ fontSize: "0.8rem" }}>
                          <button
                            className="btn btn-sm btn-outline-secondary me-2"
                            style={{ fontSize: "0.8rem" }}
                            onClick={() => {
                              dispatch({
                                type: "REMOVE_ITEM_FROM_CART",
                                payload: item._id,
                              });
                            }}
                          >
                            -
                          </button>
                          <span>{item.quantity}</span>
                          <button
                            className="btn btn-sm btn-outline-secondary ms-2"
                            style={{ fontSize: "0.8rem" }}
                            onClick={() => {
                              if (item.quantity >= item.stock) {
                                toast.error(
                                  <>
                                    <p>😪 No hay mas stock :</p>
                                    <p>{item.name}</p>
                                  </>,
                                  {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                  },
                                );
                              } else {
                                dispatch({
                                  type: "ADD_ITEM_FROM_CART",
                                  payload: item._id,
                                });
                              }
                            }}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  ¡Aún no hay articulos en el carrito!
                </div>
              )}
            </div>
            <div className="cart-shipping-info shadow rounded my-5">
              <div className="d-flex justify-content-center align-items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="shipping-fast"
                  className="svg-inline--fa fa-shipping-fast fa-w-20 mx-2"
                  role="img"
                  viewBox="0 0 640 512"
                  width="2em"
                  height="2em"
                >
                  <path
                    fill="currentColor"
                    d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                  />
                </svg>
                <h5 className="p-3">Envío express gratis en pedidos mayores a $1000</h5>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 mb-5">
          <div className="mx-4 shadow rounded p-3">
            <table className="table">
              Total
              <tbody>
                <tr>
                  <th scope="row" colSpan="2">
                    Subtotal
                  </th>
                  <td colSpan="2">${subtotal}</td>
                </tr>
                <tr>
                  <td colSpan="2" className="align-middle">
                    {subtotal < 1000 ? (
                      <Form.Select
                        aria-label="Default select example"
                        className="mt-4"
                        onChange={(ev) => selectShipping(ev)}
                      >
                        <option>Seleccione envío:</option>
                        <option value="0">gratis (7-9 días)</option>
                        <option value="200">estándar (5-7 días) $200</option>
                        <option value="500">express $500</option>
                      </Form.Select>
                    ) : (
                      <div className="d-flex align-items-center justify-content-center p-0">
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="shipping-fast"
                          className="svg-inline--fa fa-shipping-fast fa-w-20 mx-2"
                          role="img"
                          viewBox="0 0 640 512"
                          width="1.5em"
                          height="1.5em"
                        >
                          <path
                            fill="currentColor"
                            d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                          />
                        </svg>
                        Tenes envío express gratis!{" "}
                      </div>
                    )}
                  </td>
                  <td colSpan="2">
                    <p className="mt-4">$ {shippingCost}</p>
                  </td>
                </tr>
                <tr>
                  <th scope="row" colSpan="2" style={{ fontWeight: "800" }}>
                    Total
                  </th>
                  <td>$ {shippingCost + subtotal}</td>
                </tr>
              </tbody>
            </table>
            <div className="mx-auto d-flex justify-content-center">
              <Link
                to="/productos"
                className="btn bt-sm btn-secondary d-flex align-items-center m-3"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="shopping-bag"
                  className="svg-inline--fa fa-shopping-bag fa-w-14"
                  role="img"
                  viewBox="0 0 448 512"
                  width="1em"
                  height="1em"
                >
                  <path
                    fill="currentColor"
                    d="M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
                  />
                </svg>
                <span className="ps-2">Continuar comprando</span>
              </Link>
              {isLoggedIn && items.length > 0 ? (
                <Link to="/verificar" className="btn btn-wine m-3">
                  <i className="far fa-check-circle"></i>
                  <span className="ps-2">Checkout</span>
                </Link>
              ) : !isLoggedIn ? (
                <Button
                  className="btn btn-wine m-3 disabled-link"
                  onClick={() => dispatch(showNavUserAction())}
                >
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M16.848 12.168c1.56-1.32 2.448-3.216 2.448-5.232 0-3.768-3.072-6.84-6.84-6.84s-6.864 3.072-6.864 6.84c0 2.016 0.888 3.912 2.448 5.232-4.080 1.752-6.792 6.216-6.792 11.136 0 0.36 0.288 0.672 0.672 0.672h21.072c0.36 0 0.672-0.288 0.672-0.672-0.024-4.92-2.76-9.384-6.816-11.136zM12.432 1.44c3.048 0 5.52 2.472 5.52 5.52 0 1.968-1.056 3.792-2.76 4.776l-0.048 0.024c0 0 0 0-0.024 0-0.048 0.024-0.096 0.048-0.144 0.096h-0.024c-0.792 0.408-1.632 0.624-2.544 0.624-3.048 0-5.52-2.472-5.52-5.52s2.52-5.52 5.544-5.52zM9.408 13.056c0.96 0.48 1.968 0.72 3.024 0.72s2.064-0.24 3.024-0.72c3.768 1.176 6.576 5.088 6.816 9.552h-19.68c0.264-4.44 3.048-8.376 6.816-9.552z"></path>
                  </svg>
                  <span className="ps-2">Loguearse para continuar</span>
                </Button>
              ) : (
                <Button className="btn btn-wine m-3 disabled-link">
                  <span className="ps-2">😯 Carrito Vacio</span>
                </Button>
              )}
            </div>
            <div className="d-flex gap-2 align-items-center">
              <h3>Aceptamos:</h3>
              <img src="/img/visa.gif" className="img-fluid" alt="" />
              <img src="/img/oca.gif" className="img-fluid" alt="" />
              <img src="/img/creditel.png" className="img-fluid" alt="" />
              <img src="/img/master.svg" className="img-fluid" alt="" />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ShoppingCartPage;
